import styles from "./GeoSelector.module.css";

export const GeoSelector = ({
    position,
}: {
    position: "absolute" | "relative";
}): React.ReactElement => {
    // TODO: get the actual list from the CMS or something?
    const geos = ["UK", "MI", "NJ"];
    return (
        <div
            className={[
                styles.listWrapper,
                styles[`listWrapper-${position}`],
            ].join(" ")}
        >
            {geos[0]}
            <ol className={styles.list}>
                {geos.map((geo, index) => {
                    const animationDelay = `${(index + 1) * 60}ms`;
                    const destination = getDestination(geo);
                    return (
                        <li
                            key="{geo}"
                            style={{ animationDelay: animationDelay }}
                            className={styles.listItem}
                        >
                            <a href={destination}>{geo}</a>
                        </li>
                    );
                })}
            </ol>
        </div>
    );
};

const getDestination = (geo: string): string => {
    const url = new URL(window.location.href);
    url.pathname += geo;
    return url.href;
};
